import { Button, Divider, Stack, Typography } from '@mui/material'
import { applyNextSearch } from '@/features/search/slice'
import {
  dismissAll,
  enqueueToast,
  type ToastDismissMode,
  type ToastSeverity,
} from '@/features/toasts/slice'
import { useAppDispatch } from '@/redux/hooks'

const severities: ToastSeverity[] = ['success', 'info', 'warning', 'error']

export const ToastKitchenSink = () => {
  const dispatch = useAppDispatch()

  const fire = (
    severity: ToastSeverity,
    dismissMode: ToastDismissMode = 'auto',
  ) =>
    dispatch(
      enqueueToast({
        severity,
        message: `[${severity}] ${dismissMode} toast fired at ${new Date().toLocaleTimeString()}`,
        dismissMode,
      }),
    )

  return (
    <Stack spacing={2} sx={{ p: 1, minWidth: 280 }}>
      <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
        {severities.map((s) => (
          <Button
            key={s}
            size="small"
            variant="outlined"
            color={
              s === 'error'
                ? 'error'
                : s === 'warning'
                  ? 'warning'
                  : s === 'success'
                    ? 'success'
                    : 'info'
            }
            onClick={() => fire(s)}
          >
            {s}
          </Button>
        ))}
      </Stack>

      <Divider />

      <Typography variant="caption" color="text.secondary">
        requires-interaction
      </Typography>
      <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
        {severities.map((s) => (
          <Button
            key={s}
            size="small"
            variant="outlined"
            color={
              s === 'error'
                ? 'error'
                : s === 'warning'
                  ? 'warning'
                  : s === 'success'
                    ? 'success'
                    : 'info'
            }
            onClick={() => fire(s, 'requires-interaction')}
          >
            {s}
          </Button>
        ))}
      </Stack>

      <Divider />

      <Typography variant="caption" color="text.secondary">
        search-dismisses
      </Typography>
      <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
        {severities.map((s) => (
          <Button
            key={s}
            size="small"
            variant="outlined"
            color={
              s === 'error'
                ? 'error'
                : s === 'warning'
                  ? 'warning'
                  : s === 'success'
                    ? 'success'
                    : 'info'
            }
            onClick={() => fire(s, 'search-dismisses')}
          >
            {s}
          </Button>
        ))}
      </Stack>
      <Button
        size="small"
        variant="outlined"
        color="inherit"
        onClick={() => dispatch(applyNextSearch())}
      >
        Simulate Search (dismiss)
      </Button>

      <Divider />

      <Button
        size="small"
        color="inherit"
        variant="outlined"
        onClick={() => dispatch(dismissAll())}
      >
        Dismiss All
      </Button>
    </Stack>
  )
}
